/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  customButtonContainer: 'customButtonContainer_2f344982',
  icon: 'icon_2f344982',
  themeDarkAltColor: 'themeDarkAltColor_2f344982',
  leftText: 'leftText_2f344982',
  splitter: 'splitter_2f344982',
  button: 'button_2f344982',
  darkerBG: 'darkerBG_2f344982',
};

export = styles;

loadStyles([{"rawString":".customButtonContainer_2f344982{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.icon_2f344982{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;speak:none;font-size:14px;position:relative}.themeDarkAltColor_2f344982{color:"},{"theme":"themeDarkAlt","defaultValue":"#106ebe"},{"rawString":"}.leftText_2f344982{margin-left:6px;font-size:14px;font-weight:400;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":"}.splitter_2f344982{font-size:14px;font-weight:400;color:"},{"theme":"neutralTertiary","defaultValue":"#a6a6a6"},{"rawString":";background:0 0;position:relative;top:-2px;height:40px}.button_2f344982.ms-Button{height:40px;min-width:28px;padding:0 5px}.button_2f344982:hover{background:initial}.darkerBG_2f344982{background:#d0d0d0}"}]);
/* tslint:enable */